export const it = {
  core: {
    pageTitle: 'Components Library',
    dialogContacts: {
      title: 'Prenota una consulenza',
      description:
        'Un nostro esperto ti contatterà a breve per fornirti maggiori informazioni sul piano di interesse o per effettuare una modifica.',
      modes: {
        contactMe: {
          label: 'Contattami',
          description:
            'Verifica i dati che verranno usati per contattarti, prima di inviare la richiesta.',
        },
        contactOther: {
          label: 'Contatta un’altra persona',
          description: 'Inserisci i dati del referente per il ricontatto.',
        },
      },
      contactMe: {
        header: 'I tuoi dati',
      },
      contactOther: {
        header: 'Dati della persona da contattare',
      },
      fields: {
        firstName: 'Nome',
        firstNamePlaceholder: 'Es: Marco',
        lastName: 'Cognome',
        lastNamePlaceholder: 'Es: Rossi',
        email: 'Email',
        emailPlaceholder: 'Es: marco.rossi@email.com',
        phone: 'Telefono',
        phonePlaceholder: 'Es: +39 333 1234567',
        messageOptional: 'Messaggio (facoltativo)',
        messagePlaceholder: 'es: Vorrei valutare un offerta customizzata',
      },
      buttons: {
        cancel: 'Annulla',
        send: 'Invia',
      },
      success: {
        title: 'Richiesta inviata con successo!',
        description: 'Abbiamo ricevuto la tua richiesta di contatto.',
        close: 'Chiudi',
        cta: 'Torna alla Homepage',
      },
      error: {
        title: 'Ops, qualcosa è andato storto!',
        description:
          'Non siamo riusciti a inviare la tua richiesta. Verifica i dati inseriti e riprova. Se il problema persiste, attendi qualche minuto e riprova più tardi.',
        close: 'Chiudi',
        retry: 'Riprova',
      },
    },
  },
};
